/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { getEmailConfig, saveEmailConfig } from '../services/api';
import './EmailConfig.css';

function EmailConfig() {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });

  const [formData, setFormData] = useState({
    host: '',
    port: 587,
    secure: false,
    user: '',
    pass: '',
    from: '',
    adminEmail: ''
  });

  const [emailTemplates, setEmailTemplates] = useState({
    customerConfirmation: {
      subject: '',
      body: ''
    },
    adminNotification: {
      subject: '',
      body: ''
    }
  });

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      setLoading(true);
      const data = await getEmailConfig();
      if (data.emailTemplates) {
        setEmailTemplates(data.emailTemplates);
      }
      setFormData(prev => ({ ...prev, ...data }));
    } catch (error) {
      showMessage('error', 'Fehler beim Laden der Konfiguration');
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: '', text: '' }), 5000);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleTemplateChange = (templateType, field, value) => {
    setEmailTemplates(prev => ({
      ...prev,
      [templateType]: {
        ...prev[templateType],
        [field]: value
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const dataToSave = {
        ...formData,
        emailTemplates
      };
      await saveEmailConfig(dataToSave);
      showMessage('success', 'E-Mail-Konfiguration erfolgreich gespeichert');
    } catch (error) {
      showMessage('error', 'Fehler beim Speichern der Konfiguration');
    }
  };

  if (loading) {
    return <div className="loading">Lade Konfiguration...</div>;
  }

  return (
    <div className="email-config">
      {message.text && (
        <div className={`alert alert-${message.type}`}>{message.text}</div>
      )}

      <div className="card">
        <h2>E-Mail-Konfiguration</h2>
        <p className="info-text">
          Konfigurieren Sie hier die SMTP-Einstellungen für den E-Mail-Versand von Mock-Ups.
          Die eingegebenen Daten werden sicher auf dem Server gespeichert.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="smtp-host">SMTP-Host *</label>
              <input
                id="smtp-host"
                type="text"
                name="host"
                value={formData.host}
                onChange={handleInputChange}
                placeholder="smtp.beispiel.de"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="smtp-port">Port *</label>
              <input
                id="smtp-port"
                type="number"
                name="port"
                value={formData.port}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="smtp-user">Benutzername/E-Mail *</label>
            <input
              id="smtp-user"
              type="text"
              name="user"
              value={formData.user}
              onChange={handleInputChange}
              placeholder="ihr-name@beispiel.de"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="smtp-pass">Passwort *</label>
            <input
              id="smtp-pass"
              type="password"
              name="pass"
              value={formData.pass}
              onChange={handleInputChange}
              placeholder="••••••••"
            />
            <small>Lassen Sie das Feld leer, um das vorhandene Passwort nicht zu ändern.</small>
          </div>

          <div className="form-group">
            <label htmlFor="smtp-from">Absender-E-Mail *</label>
            <input
              id="smtp-from"
              type="email"
              name="from"
              value={formData.from}
              onChange={handleInputChange}
              placeholder="noreply@beispiel.de"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="admin-email">Admin-E-Mail (Bestellungen) *</label>
            <input
              id="admin-email"
              type="email"
              name="adminEmail"
              value={formData.adminEmail}
              onChange={handleInputChange}
              placeholder="admin@beispiel.de"
              required
            />
            <small>An diese E-Mail-Adresse werden Bestellungen gesendet.</small>
          </div>

           <div className="form-group">
            <label className="checkbox-label" htmlFor="smtp-secure">
              <input
                id="smtp-secure"
                type="checkbox"
                name="secure"
                checked={formData.secure}
                onChange={handleInputChange}
              />
              <span>SSL/TLS verwenden (empfohlen)</span>
            </label>
          </div>

          <hr style={{ margin: '30px 0', borderColor: '#ddd' }} />

          <h3>E-Mail-Templates</h3>
          <div className="variables-info">
            <h4>Verfügbare Variablen</h4>
            <p className="info-text">Verwenden Sie diese Platzhalter in Betreff und Nachricht. Sie werden beim Versand automatisch ersetzt:</p>
            <table className="variables-table">
              <thead>
                <tr>
                  <th>Variable</th>
                  <th>Beschreibung</th>
                  <th>Beispiel</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>{'{{customerName}}'}</code></td>
                  <td>Name des Kunden</td>
                  <td>Max Mustermann</td>
                </tr>
                <tr>
                  <td><code>{'{{customerEmail}}'}</code></td>
                  <td>E-Mail-Adresse des Kunden</td>
                  <td>max@beispiel.de</td>
                </tr>
                <tr>
                  <td><code>{'{{productType}}'}</code></td>
                  <td>Produktkategorie</td>
                  <td>Dog-Tag / Holz-Anhänger</td>
                </tr>
                <tr>
                  <td><code>{'{{productName}}'}</code></td>
                  <td>Name des gewählten Produkts</td>
                  <td>Knochen Gold / Herz 43mm</td>
                </tr>
              </tbody>
            </table>
            <p className="info-text" style={{ marginTop: '1rem' }}>
              <strong>Hinweis:</strong> Bei Neukunden (keine Bestandskunden der Tierarztpraxis) wird automatisch ein Adressblock an die Admin-Benachrichtigung angehängt.
            </p>
          </div>

          <h4>Kundenbestätigung</h4>
          <div className="form-group">
            <label htmlFor="customer-subject">Betreff *</label>
            <input
              id="customer-subject"
              type="text"
              value={emailTemplates.customerConfirmation.subject}
              onChange={(e) => handleTemplateChange('customerConfirmation', 'subject', e.target.value)}
              placeholder="Bestellbestätigung - Gravur Mock-Up"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="customer-body">Nachricht *</label>
            <textarea
              id="customer-body"
              rows="8"
              value={emailTemplates.customerConfirmation.body}
              onChange={(e) => handleTemplateChange('customerConfirmation', 'body', e.target.value)}
              placeholder="Hallo {{customerName}},&#10;&#10;vielen Dank für Ihre Bestellung!&#10;..."
              required
              style={{ fontFamily: 'monospace', fontSize: '13px' }}
            />
          </div>

          <h4>Admin-Benachrichtigung</h4>
          <div className="form-group">
            <label htmlFor="admin-subject">Betreff *</label>
            <input
              id="admin-subject"
              type="text"
              value={emailTemplates.adminNotification.subject}
              onChange={(e) => handleTemplateChange('adminNotification', 'subject', e.target.value)}
              placeholder="Neue Bestellung - Gravur Mock-Up"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="admin-body">Nachricht *</label>
            <textarea
              id="admin-body"
              rows="8"
              value={emailTemplates.adminNotification.body}
              onChange={(e) => handleTemplateChange('adminNotification', 'body', e.target.value)}
              placeholder="Neue Bestellung eingegangen:&#10;&#10;Kunde: {{customerName}}&#10;E-Mail: {{customerEmail}}&#10;..."
              required
              style={{ fontFamily: 'monospace', fontSize: '13px' }}
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-primary">
              Konfiguration speichern
            </button>
          </div>
        </form>
      </div>

      <div className="email-help">
          <h3>Hilfe & Beispiele</h3>
          <div className="help-grid">
            <div className="help-section">
                <h4>Gmail</h4>
                <ul>
                <li>Host: smtp.gmail.com</li>
                <li>Port: 587 (oder 465 mit SSL)</li>
                <li>Sie benötigen ein <a href="https://myaccount.google.com/apppasswords" target="_blank" rel="noopener noreferrer">App-Passwort</a> (2FA muss aktiviert sein).</li>
                </ul>
            </div>
            <div className="help-section">
                <h4>Outlook/Office365</h4>
                <ul>
                <li>Host: smtp.office365.com</li>
                <li>Port: 587</li>
                <li>Verwenden Sie Ihre normale E-Mail und Passwort.</li>
                </ul>
            </div>
          </div>
        </div>
    </div>
  );
}

export default EmailConfig;
